<script>
import { mapState } from 'vuex';
import Loading from '../../components/loading.vue';

export default {
    name: "artist",
    data() {
        return {
            isLoading: false,
            list: [],
            page: 1,
            allPage: 1,
        };
    },
    computed: {
        ...mapState(['galleryHome']),
    },
    components: {
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {},
    methods: {
        getData() { 
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            this.$store.dispatch('getGalleryArtist', {
                page: this.page,
                limit: 12
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.list = result.data.list;
                    this.allPage = result.data.last_page;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getData();
        }
    },
};
</script>

<template>
    <div class="artist layout_body">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg" :style="`background-image: url(${galleryHome.artist_banner});`"></div>
        </div>
        <div class="layout_main">
            <div class="layout_content">
                <p class="breadcrumb only_pc"><router-link to="/gallery">A<sup>+</sup> Studio Gallery</router-link> / 艺术家</p>
                <div class="list flex flex_wrap">
                    <router-link class="item" v-for="(item, index) in list" :key="index" :to="`/gallery/artist/detail?id=${item.id}`">
                        <div class="layout_bg cover" :style="`background-image: url(${item.image1});`"></div>
                        <div class="name">{{ item.name }}</div>
                    </router-link>
                </div>
                <Loading v-if="isLoading"/>
                <p class="no_more" v-else-if="list.length == 0">暂无更多内容</p>
                <p class="no_more" v-else-if="page == allPage">已经到底了</p>
                <div class="flex justify_end" v-else>
                    <div class="layout_btn_more" @click="getMore">加载更多</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: .3rem 0;
    }
}
.content{
    gap: .5rem;
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.list{
    gap: .4rem;
    .item{
        width: 2.5rem;
        text-align: center;
        font-size: .2rem;
        line-height: 1.6;
        .cover{
            height: 0;
            padding-bottom: 100%;
            // border: 1px solid #666;
            margin-bottom: .2rem;
        }
    }
    @media only screen and (max-width: 750px) {
        gap: .3rem;
        .item{
            width: 3.3rem;
            font-size: .28rem;
        }
    }
}
.layout_btn_more{
    border-bottom: 1px solid #666;
    @media only screen and (max-width: 750px) {
        margin: .3rem auto 0;
    }
}

</style>